import React from 'react';
import styles from './LoadingSpinner.module.css';
import cn from 'classnames';

type LoadingSpinnerProps = {
    containerClassName?: string;
    spinnerClassName?: string;
};

const LoadingSpinner = ({ containerClassName, spinnerClassName }: LoadingSpinnerProps) => {
    return (
        <div className={cn(styles.container, containerClassName)}>
            <div className={cn(styles.loadingSpinner, spinnerClassName)} />
        </div>
    );
};

export default LoadingSpinner;
